<template>
  <b-row>
    <b-col>
      <b-card no-body>

        <b-card-header>
          <h4 class="mb-0">
            Devices
          </h4>
          <b-card-text>
            <!--
            <b-button
              variant="outline-primary"
            >Edit</b-button>-->
          </b-card-text>
        </b-card-header>

        <b-table
          :items="devices"
          :fields="deviceFields"
          hover
          show-empty
          empty-text="No Devices Found"
          @row-clicked="onRowClick"
        />
      </b-card>
    </b-col>

  </b-row>

</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardText,
  // BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BCard,
    BCardHeader,
    BRow,
    BCol,
    BCardText,
    // BButton,
  },
  props: {
    object: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      deviceFields: [
        { key: 'name', label: 'Device Name', sortable: true },
        { key: 'manufacturerSerialNumber', label: 'Serial Number', sortable: true },
        { key: 'deviceModel.name', label: 'Device Name', sortable: true },
        { key: 'positionOnObject', label: 'Position On Object', sortable: true },
      ],
    }
  },
  methods: {
    onRowClick(row) {
      this.$router.push(`/devices/${row.id}`)
    },
  },
}
</script>

<style>

</style>
